module.exports = __webpack_public_path__ + "static/img/index_1.efeb8d3e.png";